import { Form, Input, InputNumber, Select } from 'antd';
import type { TruckClass } from '../reference-data/reference-data.api';

/** Class, make/model, year, GPS device, VIN and engine number — shared by create and edit (CreateTruckDrawer, TruckDetailsForm). */
export function TruckParticularsFields({ truckClasses }: { truckClasses: TruckClass[] }) {
  return (
    <>
      <Form.Item name="classCode" label="Class" rules={[{ required: true, message: 'Select a class' }]}>
        <Select options={truckClasses.map((c) => ({ value: c.code, label: c.name }))} showSearch optionFilterProp="label" />
      </Form.Item>
      <div className="grid grid-cols-2 gap-3">
        <Form.Item name="make" label="Make" rules={[{ required: true, message: 'Enter a make' }]}>
          <Input />
        </Form.Item>
        <Form.Item name="model" label="Model" rules={[{ required: true, message: 'Enter a model' }]}>
          <Input />
        </Form.Item>
      </div>
      <div className="grid grid-cols-2 gap-3">
        <Form.Item name="year" label="Year" rules={[{ required: true, message: 'Enter a year' }]}>
          <InputNumber className="w-full" min={1980} step={1} />
        </Form.Item>
        <Form.Item name="gpsDeviceId" label="GPS device ID">
          <Input />
        </Form.Item>
      </div>
      <div className="grid grid-cols-2 gap-3">
        <Form.Item name="vin" label="VIN / chassis" rules={[{ required: true, message: 'Enter a VIN' }]}>
          <Input />
        </Form.Item>
        <Form.Item name="engineNumber" label="Engine number" rules={[{ required: true, message: 'Enter an engine number' }]}>
          <Input />
        </Form.Item>
      </div>
    </>
  );
}
